import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { palette, radius } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';

const Banner = styled(Box)`
    width: 100%;
    height: 100%;
    position: relative;
    background-color: ${palette("neutral.800")};
    border-radius: ${radius("base")};
    overflow: hidden;
`;
const Overlay = styled(Box)`
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    flex-grow: 0;
    > * {
        flex-shrink: 0;
    }
`;
const TextWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
`;
const Image = styled("img")`
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export { Banner, Image, Overlay, TextWrapper };
//# sourceMappingURL=styled.es.js.map
